module.exports = __webpack_public_path__ + "static/img/14003008.2b3ae990.png";